import { PositionSlotValidationProvider } from 'domain/people/positionSlots/preview/List/PositionSlotValidationContext';
import { bindCollection, CollectionView } from 'framework/ViewTypes/contentLayout';
import { getColumns } from './positionsTableConfig';
import usePositionsCollection from './usePositionsCollection';
import { usePositionSlotsUrl } from 'domain/shared/positionSlot';

const PositionsList = ({ collection }: { collection: ReturnType<typeof usePositionsCollection> }) => {
  const { getSingleEntityUrl } = usePositionSlotsUrl();
  const binding = bindCollection(collection, {
    columns: getColumns(getSingleEntityUrl),
    emptyContent: 'No positions found.',
  });

  return (
    <PositionSlotValidationProvider positionSlots={collection.rows} loading={collection.isLoading}>
      <CollectionView {...binding.contentProps} sx={{ p: 0 }} />
    </PositionSlotValidationProvider>
  );
};

export default PositionsList;
